import type {ReactElement} from 'react';
import React from 'react';
import {CustomScaledDimensionsInfoBox} from '@Components/poster-editor/components/custom-item-controls/components/custom-scaled-dimensions-info-box/custom-scaled-dimensions-info-box';
import {CustomItemUnlockControl} from '@Components/poster-editor/components/custom-item-unlock-control/custom-item-unlock-control';
import {CustomRotationControl} from '@Components/poster-editor/components/custom-rotation-control/custom-rotation-control';
import {CustomItemControlTl} from '@Components/poster-editor/components/custom-item-control-tl/custom-item-control-tl';
import {CustomItemControlBl} from '@Components/poster-editor/components/custom-item-control-bl/custom-item-control-bl';
import {CustomItemControlTr} from '@Components/poster-editor/components/custom-item-control-tr/custom-item-control-tr';
import {CustomItemControlBr} from '@Components/poster-editor/components/custom-item-control-br/custom-item-control-br';
import type {CustomItemControlsWrapperProps} from '@Components/poster-editor/components/custom-item-controls/components/custom-item-controls-wrapper/custom-item-controls-wrapper.types';

export function ActiveSelectionCustomControls(props: CustomItemControlsWrapperProps): ReactElement | null {
  return (
    <>
      <CustomItemUnlockControl pageHashedId={props.pageHashedId} />
      <CustomRotationControl pageHashedId={props.pageHashedId} />

      <CustomItemControlTl pageHashedId={props.pageHashedId} />
      <CustomItemControlBl pageHashedId={props.pageHashedId} />
      <CustomItemControlTr pageHashedId={props.pageHashedId} />
      <CustomItemControlBr pageHashedId={props.pageHashedId} />
      <CustomScaledDimensionsInfoBox pageHashedId={props.pageHashedId} />
    </>
  );
}
